import { Component, OnInit } from '@angular/core';
import { LinkItem } from '../link-item';
import { LoginService } from '../security/login.service';
import { HttpService } from '../service/http.service';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-links',
  templateUrl: './links.component.html',
  styleUrls: ['./links.component.css']
})
export class LinksComponent implements OnInit {

  linkItems: LinkItem[] = [];

  constructor(
    private loginService: LoginService,
    private httpService: HttpService,
    private titleService: Title
  ) {
    this.loginService.activatedNavigationComponent = false;
    this.titleService.setTitle("Homepage Langues Vivantes");
   }

  ngOnInit() {
    this.httpService.getAllLinkItems().subscribe(res => {
      this.linkItems = res;
    });
  }

}
